(function () {
    'use strict';

    angular.module('swif.ui')

        .component('swifCarouselLightbox', {
            templateUrl: 'partials/ui/carousel_lightbox.html',
            controller: swifCarouselLightboxController,
            bindings: {
                images: '='
            }
        })

        .directive('swifImg', swifImg)
        .directive('swifCarousel', swifCarousel)
        .directive('swifInputImg', swifInputImg);


    function swifCarouselLightboxController($scope, swif, $uibModal) {
        var $ctrl = this;
        $ctrl.myInterval = 1000;
        $ctrl.slides = [];

        $ctrl.open = function (indexSlide) {
            $ctrl.active_slide = indexSlide;
            var modalInstance = $uibModal.open({
                animation: true,
                size : 'lg',
                templateUrl: 'template-carousel-zoom-modal',
                scope: $scope
            });
        };

        $scope.$watch('$ctrl.images', function (newV) {
            if (newV) {
                if ($ctrl){
                    $ctrl.slides = [];
                    for (var i = 0; i < $ctrl.images.length; i++) {
                        $ctrl.slides.push({
                            text: $ctrl.images[i].name,
                            image: $ctrl.images[i],
                            id: i
                        });
                    }
                }
            }
        });
    }

    /**
     * @ngdoc directive
     * @name swif.ui:swifImg
     * @module swif.ui
     * @restrict E
     * @description display an image
     */
    function swifImg(swif) {
        'ngInject';
        return {
            restrict: 'E',
            scope: {
                alt: '@?',
                model: '@?',
                field: '@?',
                rawData: '=?'
            },
            replace: true,
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {
                /**
                 * /web/binary/image?
                 *     session_id=XXX
                 *     &model=base.language.install
                 *     &id=
                 *     &field=config_logo
                 *     &t=1431532622454
                 * @return {[type]} [description]
                 */
                var url;
                scope.isAttachment = function (value) {
                    if (value) {
                        return value.datas_fname;
                    }
                    return false;
                };
                ngModel.$render = function () {
                    var vv = ngModel.$viewValue;
                    var model, field;
                    if (scope.isAttachment(vv)) {
                        model = 'ir.attachment';
                        field = 'datas';
                        scope.isImage = swif.attachment.isImage(vv);
                        if (!scope.alt) {
                            scope.alt = vv.datas_fname;
                        }
                    } else {
                        model = scope.model;
                        field = scope.field;
                        // @TODO: we should use a 'filename' field to check the extension file,
                        // but it works only if the model (server-side) defines a filename field
                        // for its binary field
                        scope.isImage = true;
                        if (!scope.alt) {
                            scope.alt = vv.name || '';
                        }
                    }
                    if (!scope.rawData && vv && vv.id) {
                        url = '/web/binary/image';
                        url += '?session_id=' + swif.user.getAuthenticatedUser().session_id;
                        url += '&model=' + model;
                        url += '&id=' + vv.id;
                        url += '&field=' + field;
                    } else if (scope.rawData) {
                        url = 'data:image/png;base64,' + scope.rawData;
                    } else {
                        url = '/web/static/src/img/placeholder.png';
                    }
                    scope.src = url;
                };
                scope.$watchGroup(['alt', 'model', 'field', 'rawData'], function (newV, oldV) {
                    if (!angular.equals(newV, oldV)) {
                        // recompute the swif-img when setting changes
                        ngModel.$render();
                    }
                }, true);
            },
            template: '<img ng-show="isImage" alt="{{alt}}" ng-src="{{src}}"/>'
        };
    }

    /**
     * @ngdoc directive
     * @name swif.ui:swifCarousel
     * @module swif.ui
     * @restrict E
     * @description display a carousel from a list of attachments
     */
    function swifCarousel(swif) {
        'ngInject';
        return {
            restrict: 'E',
            scope: {
                options: '=?'
            },
            replace: true,
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {
                _.defaults(scope.options, {
                    interval: 5000
                });
                scope.attachments = [];
                scope.pagination = {};
                var setNextPhoto = function () {
                    var index, next, length;
                    index = scope.attachments.indexOf(scope.attachment);
                    length = scope.attachments.length;
                    if (index === -1) {
                        next = 0;
                    } else {
                        if (index + 1 <= length - 1) {
                            next = index + 1;
                        } else {
                            next = 0;
                        }
                    }
                    scope.pagination.page = next + 1;
                    scope.attachment = scope.attachments[next];
                };
                ngModel.$render = function () {
                    var vv = ngModel.$viewValue;
                    scope.attachments = [];
                    if (_.isArray(vv)) {
                        scope.attachments = swif.attachment.getImages(vv);
                        setNextPhoto();
                    } else if (_.isObject(vv)) {
                        swif.attachment.getImages(vv)
                            .then(function (attachments) {
                                scope.attachments = attachments;
                                if (scope.attachments.length > 0) {
                                    setNextPhoto();
                                }
                            });
                    }
                };
                scope.$watch('pagination.page', function (newV) {
                    if (newV) {
                        var index = scope.attachments.indexOf(scope.attachment);
                        if (index !== newV - 1) {
                            scope.attachment = scope.attachments[newV - 1];
                        }
                    }
                });
            },
            templateUrl: 'partials/ui/carousel.html'
        };
    }

    /**
     * @ngdoc directive
     * @name swif.ui:swifInputImg
     * @module swif.ui
     * @restrict E
     * @description
        Form input used to upload (without auto-saving data) an image,
        with a preview of the uploaded image
     */
    function swifInputImg(swif) {
        'ngInject';
        return {
            restrict: 'E',
            replace: false,
            scope: {
                fieldImg: '@',
                fieldPreview: '@?',
                type: '@?',
                sizeImg: '=?'
            },
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {
                scope.getModelName = function () {
                    var type = scope.type || scope.proxy.model._type;
                    var ret = '';
                    if (type) {
                        ret = swif.settings.getContentType(type).model;
                    }
                    return ret;
                };

                scope.sync = function () {
                    scope.proxy.model[scope.fieldImg] = scope.proxy.newValue || false;
                    ngModel.$setViewValue(scope.proxy.model);
                };

                scope.removeValue = function () {
                    scope.proxy.newValue = null;
                };

                scope.randomId = function () {
                    var now = moment();
                    return now.unix() + now.milliseconds();
                };

                scope.getPreviewImg = function () {
                    scope.initialize = true;
                    scope.changed = false;
                    var preview = scope.fieldPreview || scope.fieldImg;
                    if (preview) {
                        swif.data.get(
                            scope.type || scope.proxy.model._type,
                            scope.proxy.model.id,
                            {fields: [preview]}
                        ).then(function (data) {
                            scope.proxy.newValue = data[preview];
                        });
                    }
                };

                scope.proxy = {
                    newValue: null,
                    model: {},
                    modelName: scope.getModelName(),
                    changed: false,
                    initialize: true
                };
                if (!scope.sizeImg) {
                    scope.sizeImg = 'medium';
                }

                scope.randId = scope.randomId();

                ngModel.$render = function () {
                    var vv = ngModel.$viewValue;
                    scope.proxy.model = vv;
                    scope.proxy.modelName = scope.getModelName();
                    scope.getPreviewImg();
                };

                scope.$watch('proxy.newValue', function (newV, oldV) {
                    if (!angular.equals(newV, oldV)) {
                        scope.sync();
                        if (!scope.initialize) {
                            scope.changed = true;
                        }
                    }
                });
            },
            templateUrl: 'partials/ui/widgetImage.html'
        };
    }
})();
